import {DatePipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {LotConsultation, vconsultation} from 'src/app/domain';
import {ConsultationService} from 'src/app/modules/services/consultation/consultation.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {translator} from 'src/assets/translator/translator';
import {TranslateService} from '@ngx-translate/core';
import {AppeloffreService} from '../../../../modules/services/appel-offre/appeloffre.service';
import {OuvertureOffresService} from '../../../../modules/services/acheteur/procedure-passation/ouverture-offres.service';
import {urlJoin} from '../../../../utils/urlJoin';
import {
    DialogListAttachFilesComponent
} from '../../../content-layout/pages/acheteur/appel-offre/proc-passa/ouverture-offres/dialog-list-attach-files/dialog-list-attach-files.component';
import {MatDialog} from '@angular/material/dialog';
import {DateFormatTimePipe} from 'src/app/modules/pipes/pipes/date-formatwithtime.pipe';
import {
    DialogHistoriqueDelaiComponent
} from '../../../content-layout/pages/acheteur/consulation/list-consultation/details-consultation/report-delai-shop/dialog-historique-delai/dialog-historique-delai.component';
import {ConfirmDialogService} from '../../../../modules/services/ui/confirm-dialog.service';

@Component({
    selector: 'app-consultation-details',
    templateUrl: './consultation-details.component.html',
    styleUrls: ['./consultation-details.component.css'],
})
export class ConsultationDetailsComponent implements OnInit {
    form: FormGroup;
    count: number;
    isLoading = false;
    lots: LotConsultation[] = [];
    typecommande: string;
    typecommandeAr: String;
    valfour: String;
    valmarchcadre: String;
    valmarchcadreAr: String;
    valdemfinanc: string;
    valpossigroup: string;
    valmarchgen: string;
    public current_lang = this.apptranstlte.getDefaultLang();

    consultation: vconsultation;
    translator = translator;
    fields = {
        shopNo: this.createField('', 'N° de la consultation'),

        publicDt: this.createField('', 'Date et heure de publication'),
        planNmFr: this.createField('', 'N° de référence'),
        planNmFyr: this.createField('', 'Appel d' + '\'' + 'offres'),
        acheteur: this.createField('', 'Nom de l' + '\'' + 'acheteur public'),
        dateprev: this.createField(
            '',
            'Date prévue du début de l' + '\'' + 'exécution'
        ),
        objAr: this.createField('', 'Objet de la consultation (arabe)'),
        objFr: this.createField('', 'Objet de la consultation (français)'),
        objEn: this.createField('', 'Objet de la consultation (anglais)'),
        tcommande: this.createField('', 'Type de commande'),
        annee: this.createField('', 'Année'),

        datecommencement: this.createField(
            '',
            'Date et heure du commencement d' + '\'' + 'envoi des offres'
        ),
        datedernieroff: this.createField(
            '',
            'Dernier délai de réception des offres'
        ),
        dateouverture: this.createField(
            '',
            'Date et heure d' + '\'' + 'ouverture des offres'
        ),
        dureevalid: this.createField('', 'Durée de validité de l' + '\'' + 'offre'),
        lieuouv: this.createField('', 'Lieu d' + '\'' + 'exécution'),
    };
    dataSource: MatTableDataSource<any>;
    dataSourceCons: MatTableDataSource<any>;

    labels = [
        'N° de la consultation',
        'N° de référence',
        'Appel d\'offres',
        'Date et heure de publication',
        'Nom de l' + '\'' + 'acheteur publique',
        'Objet de la consultation (arabe)',
        'Objet de la consultation (français)',
        'Objet de la consultation (anglais)',
    ];
    labelsCons = [
        'Type de commande',
        'Date et heure du commencement d' + '\'' + 'envoi des offres',
        'Dernier délai de réception des offres',
        'Date et heure d' + '\'' + 'ouverture des offres',
        'Durée de validité de l' + '\'' + 'offre',
        'Lieu d' + '\'' + 'exécution',
    ];
    data = [];
    datacons = [];
    displayedColumns = [];
    displayedColumnsCons = [];

    dataColumns = [
        'shopNo',
        'refNo',
        'msFr',
        'publicDt',
        'instNm',
        'shopNmAr',
        'shopNmFr',
        'shopNmEn',
    ];

    dataColumnsCons = [
        'pbkStrFr',
        'spRecvStartDt',
        'spRecvEndDt',
        'spOpenDt',
        'shopExpiredDays',
        'epFr',
    ];
    dataColumnsConsAr = [
        'pbkStrFr',
        'spRecvStartDt',
        'spRecvEndDt',
        'spOpenDt',
        'shopExpiredDays',
        'epFr',
    ];
    datatree: any;
    datepublic: string;
    spShopMasterId = null;
    shopNo = null;
    checkFlags: any = {
        Resultat: false,
        Winner: false
    };
    isAnnoncCardDisplayed: boolean = false;
     seq: any;


    constructor(private dateFormatTimePipe: DateFormatTimePipe,
                private consultationservice: ConsultationService,
                private toastService: ToastService,
                private router: Router,
                private apptranstlte: AppTranslateService,
                private datePipe: DatePipe,
                private activatedRoute: ActivatedRoute,
                private translateS: TranslateService,
                private offerservice: AppeloffreService,
                private confirmDialogService: ConfirmDialogService,
                public ouvertureOffresService: OuvertureOffresService,
                private dialoog: MatDialog,
    ) {
        translateS.onLangChange.subscribe(({lang}) => {
            this.current_lang = lang;
        });
    }

    ngOnInit(): void {
        this.activatedRoute.params.subscribe((params) => {
            this.spShopMasterId = params.spShopMasterId;
            this.shopNo = params.shopNo;
        });
        this.get();
        this.getClassification();
        this.getlist();
    }

    getlang() {
        return this.apptranstlte.getDefaultLang();
    }

    get() {
        if (this.getlang() === 'ar') {
            this.dataColumnsCons = this.dataColumnsConsAr;
        }
        this.consultationservice.findById(this.spShopMasterId).subscribe({
            next: (getcons) => {
                getcons['payload'].spOpenDt = this.dateFormatTimePipe.transform(getcons['payload'].spOpenDt);
                getcons['payload'].spRecvStartDt = this.dateFormatTimePipe.transform(getcons['payload'].spRecvStartDt);
                getcons['payload'].spRecvEndDt = this.dateFormatTimePipe.transform(getcons['payload'].spRecvEndDt);
                getcons['payload'].publicDt = this.dateFormatTimePipe.transform(getcons['payload'].publicDt);

                this.consultation = getcons['payload'];
                this.seq = getcons.shopModSeq;
                this.checkWinnerResult('Resultat');
                this.checkWinnerResult('Winner');
                // this.datepublic = this.datePipe.transform(
                //     this.consultation.publicDt,
                //     'yyyy-MM-dd HH:mm'
                // );
                this.valfour =
                    this.consultation.bizKindStrFr + ' , ' + this.consultation.pbkStrFr;

                this.typecommande =
                    this.consultation.pbkStrFr + ' , ' + this.consultation.bizKindStrFr;
                this.consultation.pbkStrFr = this.typecommande;
                this.consultation.publicYn = '';
                this.typecommandeAr =
                    this.consultation.pbkStrAr + ' , ' + this.consultation.bizKindStrAr;
                this.data.push(this.consultation);
                let transposedData = [];
                for (let column = 0; column < this.dataColumns.length; column++) {
                    transposedData[column] = {
                        label: this.labels[column],
                    };
                    for (let row = 0; row < this.data.length; row++) {
                        transposedData[column][`column${row}`] = this.data[row][
                            this.dataColumns[column]
                            ];
                    }
                }
                this.dataSource = new MatTableDataSource(transposedData);
                this.displayedColumns = ['label'];
                for (let i = 0; i < this.data.length; i++) {
                    this.displayedColumns.push('column' + i);
                }

                this.datacons.push(this.consultation);
                let transposedDataCons = [];
                for (let column = 0; column < this.dataColumnsCons.length; column++) {
                    transposedDataCons[column] = {
                        label: this.labelsCons[column],
                    };
                    for (let row = 0; row < this.datacons.length; row++) {
                        transposedDataCons[column][`column${row}`] = this.datacons[row][
                            this.dataColumnsCons[column]
                            ];
                    }
                }
                this.dataSourceCons = new MatTableDataSource(transposedDataCons);
                this.displayedColumnsCons = ['label'];
                for (let i = 0; i < this.datacons.length; i++) {
                    this.displayedColumnsCons.push('column' + i);
                }
            },
            error: () => {
                this.isLoading = false;
                this.toastService.error('server_error');
            },
            complete: () => {
                this.isLoading = false;
            },
        });
    }

    getClassification() {
        this.consultationservice
            .getClassificationList(this.shopNo, '00')
            .subscribe({
                next: (getclassification) => {
                    this.lots = getclassification['payload'];
                    this.count = this.lots.length;
                },
                error: () => {
                    this.isLoading = false;
                    this.toastService.error('server_error');
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
    }

    getlist() {
        this.consultationservice.getLotShopListSupp(this.shopNo).subscribe((res) => {
            
            this.datatree = res['payload'];
        });
    }

    createField(name: string, label: string) {
        return {name, label};
    }

    checkWinnerResult(ourCase) {
        
        const reqParams = {
            shopNo: this.consultation.shopNo,
            shopModSeq: this.consultation.shopModSeq
        };
        this.offerservice.getResultData('check' + ourCase + 'Consultation', null, reqParams, 'portail', 'GET').subscribe({
            next: (response) => {
                
                if (response['code'] == '200') {
                    this.checkFlags[ourCase] = response['payload'] === 'Y';
                } else {
                    console.error('Error in ConsultationDetailsComponent/checkWinnerResult:: code erreur', response['code']);
                    this.toastService.error('server_error');
                }
            },
            error: (e) => {
                console.error('Error in ConsultationDetailsComponent/checkWinnerResult:: erreur', e);
                this.toastService.error('server_error');
            },
            complete: () => {

            }
        });
    }

    openFicheListSoumissionaires() {
        if (this.checkFlags['Winner']) {
            
            const url = () => {
                if (this.ouvertureOffresService.verifyCurrentPage(this.router.url, 'portail')) {
                    return urlJoin('/portail/consultations/consultationdetails', this.spShopMasterId, this.shopNo, 'listSoumissionaires');
                } else if (this.ouvertureOffresService.verifyCurrentPage(this.router.url, 'acheteur')) {
                    return urlJoin('/acheteur/consultations/mine/details', this.spShopMasterId, this.shopNo, 'listSoumissionaires');
                } else if (this.ouvertureOffresService.verifyCurrentPage(this.router.url, 'fournisseur')) {
                    return urlJoin('/fournisseur/consultations/consultationdetailsFo', this.spShopMasterId, this.shopNo, 'listSoumissionaires');
                }
            };
            this.router.navigateByUrl(url());
        }
    }

    openFicheResultatOuverture() {
        if (this.checkFlags['Resultat']) {
            
            const url = () => {
                if (this.ouvertureOffresService.verifyCurrentPage(this.router.url, 'portail')) {
                    return urlJoin('/portail/consultations/consultationdetails', this.spShopMasterId, this.shopNo, 'resultatouverture');
                } else if (this.ouvertureOffresService.verifyCurrentPage(this.router.url, 'acheteur')) {
                    return urlJoin('/acheteur/consultations/mine/details', this.spShopMasterId, this.shopNo, 'resultatouverture');
                } else if (this.ouvertureOffresService.verifyCurrentPage(this.router.url, 'fournisseur')) {
                    return urlJoin('/fournisseur/consultations/consultationdetailsFo', this.spShopMasterId, this.shopNo, 'resultatouverture');
                }
            };
            this.router.navigateByUrl(url());
        }
    }

    openDialogListAttachedFiles(data: any) {
        
        const shopInfos = () => {
            if (data.code === 'listAnnoncesConsultationPortailAttachFiles') {
                return {
                    shopNo: data.element.shopNo,
                    shopModSeq: data.element.shopModSeq,
                    // funcType:  data.element.funcType,
                    funcType: '1',

                };
            }
        };
        // console.log('this.data[0]  ::: ',this.data[0])
        
        const dialogRef = this.dialoog.open(DialogListAttachFilesComponent, {
            disableClose: true,
            width: '90rem',
            direction: this.apptranstlte.getDir(),
            data: {
                dialogTitle: 'Pièces jointes',
                cardTitle: 'Liste pièces jointes',
                checkdate: this.data[0].spRecvEndDt,
                bidInfos: {
                    ...shopInfos(),
                    code: data.code
                },
            }
        });
        dialogRef.afterClosed().subscribe((result) => {

        });
    }


    reportHistoriqueDelai() {


        this.consultationservice
            .getHistoreportDelaiPort(this.data[0].shopNo, this.data[0].shopModSeq, 0)
            .subscribe({
                next: (data) => {
                        console.log(data)
                    if (data) {
                        if (data.length == 0) {
                            this.confirmDialogService.error('no_modif');
                        } else if ([data].length > 0) {
                            const dialogRef = this.dialoog.open(DialogHistoriqueDelaiComponent, {
                                disableClose: true,
                                direction: this.apptranstlte.getDir(),
                                data: {

                                    shopNo: this.shopNo,
                                    shopModSeq:this.data[0].shopModSeq,
                                    data: this.data[0]
                                },
                                width: '70vw',

                            });
                        }
                    }

                }
            });


    }

}
